<template>
<div class="row">
    <div class="col-md-12 text-center module-card" >
        <div class="blog-entry-sports ">
         <p></p>
            <div class="desc" >
                <h1 class="head-article" ref="searchresulthead" v-html="languageData['srchRslt']" tabindex="0"></h1>
                <div id="side_wrap" class="side animate-box">

                    <!-- <p v-html="languageData['searchterm'] +' '+search_term"></p> -->
                    <template v-if="(ajx_flag_f_loaded || (ajx_flag_f_loaded==0 && ajx_flag_s_loaded==1))">
                        <p v-if="(main_content['search_results']!=undefined || main_content['search_results'].length>0)" v-html="languageData['srchRslt']+' '+languageData['found']+', '+ languageData['searchterm'] +' '+search_term" role="alert" aria-atomic="true">
                        </p>
                    </template>

                    <div v-if="ajx_flag_first_load"><span style="color:green;font-weight:bolder;" ></span> 
                        <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="12" alt="loading" />
                    </div>
                    <div id="sub_wrapper" class="sub_wrapper">
                        <span  role="alert" aria-live="assertive" v-if="ajx_flag" class="sr-only">{{languageData['loading']}}</span>
                        <img v-if="ajx_flag" :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="20" alt="loading"/>
                        <p v-if="((main_content['search_results']===undefined || main_content['search_results'].length<=0) && !ajx_flag && !ajx_flag_first_load && !ajx_flag_second_load)" v-html="languageData['results']+' '+languageData['searchterm'] +' '+search_term" role="alert" aria-atomic="true">
                        </p>
                        <template v-for="(content,k) in main_content['search_results']" >
                            <h2 :key="'A'+k" v-html="content['text']" class="category_h"></h2>
                            <ul :id="'element_'+content['id_element']" class="category" :key="'B'+k" :aria-label="content['text']">
                                <li v-for="(result,ke) in content['data']" :key="'D'+ke">
                                    <router-link :to="'/content/'+result['id_cr']+'/?e='+result['id_element']" v-html="result['title']" > </router-link> <span> {{ result['matchpercent']}}</span>
                                </li>                                
                            </ul>
                            <div v-if="ajx_flag_second_load" :key="'AA'+k"><span style="color:green;font-weight:bolder;" ></span> 
                                <img  :src="LOCAL_HOST+'/ThemeMegazine/images/loader_dot.gif'" height="12" alt="loading"/>
                            </div>    
                            <p v-if="content['view_all']" :key="'C'+k+1">
                                <router-link :to="'/search/?q='+main_content['search_term']+'&e='+content['id_element']+'&type='+search_type+'&t=more'" v-html="content['view_all']" > </router-link>
                            </p><br :key="'jk'+k+1"/>               
                        </template>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'searchResult',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            LOCAL_HOST:this.$store.state.LOCAL_HOST,            
            search_term:'',
            languageData:this.$store.state.languageData,
            search_type:this.$route.query.type,
            ajx_flag:0,
            ajx_flag_second_load:0,            
            ajx_flag_first_load:0,
            ajx_flag_f_loaded:0,
            ajx_flag_s_loaded:0
            //first_element_list:[]    
        };        
    },
    mounted :function(){
        if(this.$route.query.type=='simple')
            this.showContent('body')
        else if(this.$route.query.type=='advanced')
            this.showContent('title')
    },
    watch: {
        // call again the method if the route changes
        '$route': 'callShowContent'
    },
	methods:{
        callShowContent(){
            if(this.$route.query.type=='simple')
                this.showContent('body')
            else if(this.$route.query.type=='advanced')
                this.showContent('title')
        },  
        showContent(type){
            this.ajx_flag=1;
            this.ajx_flag_f_loaded=0;
            this.ajx_flag_s_loaded=0;
            this.search_type=this.$route.query.type
            var api_method='get_search_results'
            if(type=='title'){
                api_method='get_advanced_search_results'
            }
            if(this.$route.query.t=='more'){
                var id_element=this.$route.query.e
            }
            this.search_term=this.$route.query.q;
            var api_private_key=this.get_api_key_mix('gets')
            const firstRequest = axios.get(this.$store.state.apiUrl+'/'+api_method,{
              params:{
                  id_company:this.$store.state.companyData['id_company'],
                  id_language:this.$store.state.companyData['id_language'],
                  id_country: this.$store.state.companyData['id_country'],
                  search_term:this.search_term,
                  id_service:this.$store.state.companyData['id_service_actual'],
                  id_element:id_element,
                  privatekey:api_private_key
              }
            })
            .then(response => {
                response = response.data; 
                //console.log(response)               
                this.main_content = response;
                //this.first_element_list = response['search_element_listing']
                this.ajx_flag=0;
                this.ajx_flag_second_load=1;                
                this.$refs.searchresulthead.focus();               
                this.$nextTick(function () {
                
                })
                             
                if(this.main_content['search_results'].length<=0 || this.main_content['search_results']==undefined){
                    this.ajx_flag_first_load=1;
                }else{
                    this.ajx_flag_f_loaded=1;
                }
                  
            })
            .catch((error) => {
                this.main_content = [];
                this.ajx_flag=0;
                this.customErrorHandler(error.response.status);
            });

            Promise.all([firstRequest])
            .then(() => {              
                if(this.$route.query.type=='simple'){
                    if(this.$route.query.t!='more'){
                         this.showContent_second_load_body(); 
                    }else{
                         this.ajx_flag_second_load=0;
                    }
                }else if(this.$route.query.type=='advanced'){
                    if(this.$route.query.t!='more'){                        
                        this.showContent_second_load_title();
                    }else{                       
                        this.ajx_flag_second_load=0;   
                    }
                }
            })

            this.web_hits();
        },

        showContent_second_load_body(){
            var api_method_pattern_val = 'get_search_results_body_extended';
            var api_private_key_val = this.get_api_key_mix('geed');            
            this.show_load_content(api_method_pattern_val,api_private_key_val);            
        },

        showContent_second_load_title(){
            var api_method_pattern_val = 'get_search_results_title_extended';
            var api_private_key_val = this.get_api_key_mix('geed');            
            this.show_load_content(api_method_pattern_val,api_private_key_val);
        },

        show_load_content(api_method_pattern_val,api_private_key_val){
            var api_method_pattern = api_method_pattern_val;
            var api_private_key=api_private_key_val;
            axios.get(this.$store.state.apiUrl+'/'+api_method_pattern,{
              params:{
                  id_company:this.$store.state.companyData['id_company'],
                  id_language:this.$store.state.companyData['id_language'],
                  id_country:this.$store.state.companyData['id_country'], 
                  search_term:this.search_term,
                  id_service:this.$store.state.companyData['id_service_actual'],          
                  privatekey:api_private_key
              }
            })
            .then(response => {
                response = response.data ;                
                this.ajx_flag_second_load=0; 
                this.ajx_flag_first_load=0; 
                this.ajx_flag=0;
                
                if(this.main_content['search_results'].length>0){
                    this.ajx_flag_s_loaded=1;
                    for(var m=0;m<response['search_results'].length;m++){
                        if(response['search_results'][m]['id_element_exists']==0){                           
                            var mcount = this.main_content['search_results'].length;
                            this.main_content['search_results'].push({'text':response['search_results'][m]['text']});
                            this.main_content['search_results'][mcount]['data']=[];
                            this.main_content['search_results'][mcount]['id_element']=[];
                            this.main_content['search_results'][mcount]['view_all']=[];                        
                            for(var n=0;n<response['search_results'][m]['data'].length;n++){                                
                                this.main_content['search_results'][mcount]['data'].push({'contentModificationDate': response['search_results'][m]['data'][n]['contentModificationDate'],
                                'date_activation': response['search_results'][m]['data'][n]['date_activation'],
                                'id_cr': response['search_results'][m]['data'][n]['id_cr'],
                                'id_element': response['search_results'][m]['data'][n]['id_element'],
                                'matchpercent': '','rank': '',
                                'title': response['search_results'][m]['data'][n]['title'],
                                'total': ''});
                            } 
                            this.main_content['search_results'][mcount]['id_element']=response['search_results'][m]['id_element'];
                            this.main_content['search_results'][mcount]['view_all']=response['search_results'][m]['view_all']; 
                        }
                    }
                    for(var i=0;i<this.main_content['search_results'].length;i++){                        
                        for(var j=0;j<response['search_results'].length;j++){
                            if(response['search_results'][j]['id_element_exists']==1){                            
                                if(this.main_content['search_results'][i]['id_element']==response['search_results'][j]['id_element']){
                                    for(var k=0;k<response['search_results'][j]['data'].length;k++){                                                                                                                                    
                                        this.main_content['search_results'][i]['data'].push({'contentModificationDate': response['search_results'][j]['data'][k]['contentModificationDate'],
                                        'date_activation': response['search_results'][j]['data'][k]['date_activation'],
                                        'id_cr': response['search_results'][j]['data'][k]['id_cr'],
                                        'id_element': response['search_results'][j]['data'][k]['id_element'],
                                        'matchpercent': '','rank': '',
                                        'title': response['search_results'][j]['data'][k]['title'],
                                        'total': ''});                                                                 
                                    }
                                }                           
                            }
                        } 
                    }
                }else{ 
                    for(var i=0;i<response['search_results'].length;i++){ 
                        this.main_content['search_results'].push({'text':response['search_results'][i]['text']});
                        this.main_content['search_results'][i]['data']=[];
                        this.main_content['search_results'][i]['id_element']=[];
                        this.main_content['search_results'][i]['view_all']=[];                        
                        for(var j=0;j<response['search_results'][i]['data'].length;j++){
                            this.main_content['search_results'][i]['data'].push({'contentModificationDate': response['search_results'][i]['data'][j]['contentModificationDate'],
                            'date_activation': response['search_results'][i]['data'][j]['date_activation'],
                            'id_cr': response['search_results'][i]['data'][j]['id_cr'],
                            'id_element': response['search_results'][i]['data'][j]['id_element'],
                            'matchpercent': '','rank': '',
                            'title': response['search_results'][i]['data'][j]['title'],
                            'total': ''});
                        } 
                        this.main_content['search_results'][i]['id_element']=response['search_results'][i]['id_element'];
                        this.main_content['search_results'][i]['view_all']=response['search_results'][i]['view_all'];                       
                    }
                }                               
                this.$nextTick(function () {
                
                })
              
            })
            .catch((error) => {
                this.customErrorHandler(error.response.status);
            });
            
        }

    }
};
</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
/*h2{color: #276d96c7;}*/
.module-card{
    padding: 0 5px 5px 20px;
    text-align: left !important;            
}
.side .category li a {
    border-bottom: 1px solid #e0e0e014;
    display: inline-block !important;
}
.side .category li span{
    font-weight: bold;
}
</style>